import { render } from "./PasswordChangeSendMailPage.vue?vue&type=template&id=c8ae549a&scoped=true"
import script from "./PasswordChangeSendMailPage.vue?vue&type=script&lang=ts"
export * from "./PasswordChangeSendMailPage.vue?vue&type=script&lang=ts"

import "./PasswordChangeSendMailPage.vue?vue&type=style&index=0&id=c8ae549a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c8ae549a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "c8ae549a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8ae549a', script)) {
    api.reload('c8ae549a', script)
  }
  
  module.hot.accept("./PasswordChangeSendMailPage.vue?vue&type=template&id=c8ae549a&scoped=true", () => {
    api.rerender('c8ae549a', render)
  })

}

script.__file = "src/views/passwordChange/PasswordChangeSendMailPage.vue"

export default script